import { useQuery } from '@tanstack/react-query'
import { getProcurementPurchaseOrderDashboardCounts } from 'api'
import {
  MyApprovalsIcon,
  NeedOffersIcon,
  OpenPOSIcon,
  ReadyForPOIcon,
  SkuResolutionIcon,
} from 'assets/icons/ProcurementDashboard'
import { Flex } from 'styling/GlobalStyles'
import { ColorVariant, Heading1, SmallText, TinyText } from 'styling/TypographyV2'
import { CountContainer, IconContainer, ItemContainer } from './DashboardCount.styles'

type TItem = {
  icon: React.ReactNode
  title: string
  description: string
  count: number
  color: string
}

export const OrderDashboardCount = () => {
  const { data } = useQuery({
    queryKey: ['procurement-purchase-order-dashboard-counts'],
    queryFn: () => getProcurementPurchaseOrderDashboardCounts(),
  })
  const items: TItem[] = [
    {
      icon: <MyApprovalsIcon />,
      title: 'PO created',
      description: 'Purchase orders created',
      count: data?.createdCount || 0,
      color: '#F4D03F',
    },
    {
      icon: <NeedOffersIcon />,
      title: 'Sent to supplier',
      description: 'Purchase orders sent to supplier',
      count: data?.sentToSupplierCount || 0,
      color: '#00A6FF',
    },
    {
      icon: <SkuResolutionIcon />,
      title: 'Partially received',
      description: 'Purchase orders partially received',
      count: data?.partiallyReceivedCount || 0,
      color: '#AF52DE',
    },
    {
      icon: <ReadyForPOIcon />,
      title: 'Received',
      description: 'Purchase orders received',
      count: data?.receivedCount || 0,
      color: '#24D07B',
    },
    {
      icon: <OpenPOSIcon />,
      title: 'Total value',
      description: 'Purchase orders total value',
      count: data?.totalValue || 0,
      color: '#30B0C7',
    },
  ]

  return (
    <CountContainer>
      {items.map((item) => (
        <Item key={item.title} item={item} />
      ))}
    </CountContainer>
  )
}

const Item = ({ item }: { item: TItem }) => {
  return (
    <ItemContainer hexColor={item.color}>
      <IconContainer hexColor={item.color}>{item.icon}</IconContainer>
      <Flex column gap='4px'>
        <Heading1>{item.count}</Heading1>
        <SmallText colorVariant={ColorVariant.SECONDARY} uppercase bold>
          {item.title}
        </SmallText>
        <TinyText colorVariant={ColorVariant.FADED}>{item.description}</TinyText>
      </Flex>
    </ItemContainer>
  )
}
